import {
    Component,
    forwardRef,
    QueryList,
    ViewChildren,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { TradslagsFilter } from "~app/features/planera/model/TradslagsFilter";
import { ArbetsorderSearchFilterComponent } from "../../components/arbetsorder-search-filter/arbetsorder-search-filter.component";
import { ArbetsorderSearchBase } from "../../models/arbetsorder-search-base";
import { ArbetsorderSearchBasePanel } from "../../models/arbetsorder-search-base-panel";
import { BylComponent } from "./byl/byl.component";
import { ArbetsorderSearchSkogligDataProduktgrupperComponent } from "./produktgrupper/arbetsorder-search-skoglig-data-produktgrupper.component";
import { ArbetsorderSearchSkogligDataSkotningAvstandComponent } from "./skotning-avstand/arbetsorder-search-skoglig-data-skotning-avstand.component";
import { ArbetsorderSearchSkogligDataTillganglighetComponent } from "./tillganglighet/arbetsorder-search-skoglig-data-tillganglighet.component";
import { ArbetsorderSearchSkogligDataTradslagComponent } from "./tradslag/arbetsorder-search-skoglig-data-tradslag.component";

@Component({
    selector: "rask-arbetsorder-search-skoglig-data",
    templateUrl: "./arbetsorder-search-skoglig-data.component.html",
    styleUrls: ["./arbetsorder-search-skoglig-data.component.scss"],
    providers: [
        { provide: ArbetsorderSearchBasePanel,
            useExisting: forwardRef(() => ArbetsorderSearchSkogligDataComponent) }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ArbetsorderSearchFilterComponent,
        RadiobuttonGroupComponent,
        FormsModule,
        HeaderComponent,
        ArbetsorderSearchSkogligDataTillganglighetComponent,
        ArbetsorderSearchSkogligDataProduktgrupperComponent,
        InputNumberComponent,
        ArbetsorderSearchSkogligDataSkotningAvstandComponent,
        CheckboxComponent,
        ArbetsorderSearchSkogligDataTradslagComponent,
        BylComponent
    ]
})
export class ArbetsorderSearchSkogligDataComponent extends ArbetsorderSearchBasePanel {
    radioButtonsArbetsorderAtgard = {
        entity: [
            { key: 1,
                value: this.texts.arbetsorder },
            { key: 0,
                value: this.texts.atgarder }
        ] as IRadiobuttonItem[],

        or_and: [
            { key: 0,
                value: this.texts.barighetAnd },
            { key: 1,
                value: this.texts.barighetOr }
        ] as IRadiobuttonItem[]
    };

    @ViewChildren(ArbetsorderSearchBase) filterPanels: QueryList<ArbetsorderSearchBase>;

    private readonly searchOnArbetsorderAtgarder = false;

    constructor() {
        super();
    }

    isDirty(): boolean {
        return this.searchFilter.skogligdata?.tillganglighet?.terrang?.length > 0 ||
            this.searchFilter.skogligdata?.tillganglighet?.vag?.length > 0 ||
            this.isset(this.searchFilter.skogligdata?.medelstamMin) ||
            this.isset(this.searchFilter.skogligdata?.medelstamMax) ||
            this.searchFilter.skogligdata?.produktgrupper?.length > 0 ||
            this.isset(this.searchFilter.skogligdata?.tradslag?.tall) ||
            this.isset(this.searchFilter.skogligdata?.tradslag?.gran) ||
            this.isset(this.searchFilter.skogligdata?.tradslag?.lov) ||
            this.isset(this.searchFilter.skogligdata?.tradslag?.contorta) ||
            this.isset(this.searchFilter.skogligdata?.skotningAvstand?.min) ||
            this.isset(this.searchFilter.skogligdata?.skotningAvstand?.max) ||
            this.searchFilter.grot?.grotanpassad ||
            this.searchFilter.barighet?.length > 0 ||
            this.searchFilter.ytstruktur?.length > 0 ||
            this.searchFilter.lutning?.length > 0 ||
            this.searchFilter.skogligdata?.searchOnArbetsorder === this.searchOnArbetsorderAtgarder;
    }

    forceUpdateFilterChange(): void {
        this.filterPanels.forEach(x => x.forceUpdateFilterChange());
    }

    get medelstamMax() {
        return (this.isset(this.searchFilter.skogligdata.medelstamMax)) ? this.searchFilter.skogligdata.medelstamMax : null;
    }

    set medelstamMax(value) {
        if (value && !this.searchFilter.skogligdata.medelstamMin) {
            this.searchFilter.skogligdata.medelstamMin = 0;
        }
        this.searchFilter.skogligdata.medelstamMax = value;
    }

    get medelstamMaxMinRule() {
        return (this.searchFilter.skogligdata.medelstamMin) ? this.searchFilter.skogligdata.medelstamMin : 0;
    }

    get medelstamMin() {
        return (this.isset(this.searchFilter.skogligdata.medelstamMin)) ? this.searchFilter.skogligdata.medelstamMin : null;
    }

    set medelstamMin(value) {
        if (value && this.searchFilter.skogligdata.medelstamMax < value) {
            this.searchFilter.skogligdata.medelstamMax = null;
        }
        this.searchFilter.skogligdata.medelstamMin = value;
    }

    hasCheckedValue(value: any) {
        return !value ? false : true;
    }

    getSearchArbetsorderOrAtgarder() {
        if(this.searchFilter.skogligdata.searchOnArbetsorder as unknown as number === 0 || this.searchFilter.skogligdata.searchOnArbetsorder === false) {
            this.searchFilter.skogligdata.tradslag = new TradslagsFilter();
            return 0;
        }
        return 1;
    }

    setSearchArbetsorderOrAtgarder(value: number) {
        this.searchFilter.skogligdata.searchOnArbetsorder = !!value;
        if (this.searchFilter.skogligdata.searchOnArbetsorder) {
            this.searchFilter.lutning = undefined;
            this.searchFilter.barighet = undefined;
            this.searchFilter.ytstruktur = undefined;
        }
    }

    private isset(value: any) {
        return value !== null && value !== undefined;
    }
}
